/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MeetDay } from '../../models/meet-day';

export interface CreateMeetDay$Params {
      body?: MeetDay
}

export function createMeetDay(http: HttpClient, rootUrl: string, params?: CreateMeetDay$Params, context?: HttpContext): Observable<StrictHttpResponse<MeetDay>> {
  const rb = new RequestBuilder(rootUrl, createMeetDay.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<MeetDay>;
    })
  );
}

createMeetDay.PATH = '/meetday';
